import styles from './styles.module.scss';
import { Button } from '../Button';
import { useTranslation } from '../../hooks';

/**
 * A reusable back button component that displays an arrow icon and localized text
 *
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement>} props - Standard HTML button attributes that get passed to the underlying Button component
 * @returns {JSX.Element} A styled back button with an arrow icon and translated "back" text
 */
export function BackButton({
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <Button isTiny isSecondary useMaxContent {...props}>
        <div className={styles.container__row}>
          <i className="fa-solid fa-arrow-left" />
          {t('back_button')}
        </div>
      </Button>
    </div>
  );
}
